import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Link, useNavigate } from "react-router-dom";
import { Empty, Progress } from "antd";
import ReactCountryFlag from "react-country-flag";

import { HiMiniCurrencyDollar, HiBriefcase } from "react-icons/hi2";
import { PiMonitorFill } from "react-icons/pi";

import { FaCircleCheck } from "react-icons/fa6";
import { FaCircle } from "react-icons/fa";

import {
  Charts,
  Loader,
  Spacer,
  boxContainer,
  task,
  Modal,
  Buttons,
  customCalendar,
  topStoriesComponents,
  progressBar,
  popover,
  getTagColor,
  StatusIndicator,
  GetProPopup,
  inputFields,
} from "../../components";

import { UtilityArrays } from "../../config";

import {
  WatchlistAction,
  OthersAction,
  ApplicationAction,
  UniversityAction,
  IndividualStudentAction,
  MeetingAction,
  SearchAction,
} from "../../store/actions";

import UpcomingMeetings from "../meeting/upcoming-meetings";
import MeetingTabs from "../../components/meeting/meeting-tabs";
import MeetingsSent from "../meeting/meetings-sent";
import MeetingsReceived from "../meeting/meetings-received";

import { Images, Colors } from "../../config";

import "./styles.css";

const colors = [
  Colors.main,
  "#5AEE9C",
  "#BE4642",
  "#73C7F6",
  "#41a89c",
  "#40DAC2",
];

const currencies = [
  { title: "USD", value: "USD" },
  { title: "GBP", value: "GBP" },
  { title: "EUR", value: "EUR" },
  { title: "AED", value: "AED" },
];

const Home = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const profileData = useSelector((state) => state?.profile?.user);
  const showTrialModal = useSelector(
    (state) => state?.profile?.user?.individualStudent?.showTrialModal
  );
  const { count } = useSelector((state) => state?.watchlist);
  const { questionnaire } = useSelector((state) => state?.questionnaire);
  const { ongoingApplicationsCount, submittedApplicationsCount } = useSelector(
    (state) => state?.application
  );

  const { meetingSentCount, meetingsAll, meetingInvitesCount } = useSelector(
    (state) => state.meeting
  );

  const {
    topStories,
    isTopStoriesLoading,
    tasks,
    isTasksLoading,
    taskPercentage,
    popularSubjects,
    suggestions,
    isSuggestionsLoading,
    isPopularSubsLoading,
  } = useSelector((state) => state?.others);
  const {
    universitiesByBudget,
    popularCountries,
    isPopularCountryLoading,
    isUniByBudgetLoading,
  } = useSelector((state) => state?.university);

  const [meetingTab, setMeetingTab] = useState("sent");
  const [showModal, setShowModal] = useState(false);
  const [currencyValue, setCurrencyValue] = useState("USD");
  const [profileArrayData, setProfileArrayData] = useState([]);
  const [uniPrefArrayData, setUniPrefArrayData] = useState([]);
  const [popularSubsArray, setPopularSubsArray] = useState([]);

  useEffect(() => {
    if (topStories?.length === 0) {
      dispatch(OthersAction.getTopStories());
    }
    if (popularSubjects?.length === 0) {
      dispatch(OthersAction.getPopularSubs());
    }
    if (suggestions?.length === 0) {
      dispatch(OthersAction.getSuggestions());
    }
    if (tasks?.length === 0) {
      dispatch(OthersAction.getTasks());
    }
    dispatch(UniversityAction.getPopularCountries());
    if (!profileData?.freeUser) {
      dispatch(ApplicationAction.getOngoingApplications({}));
      dispatch(ApplicationAction.getSubmittedApplications({}));
      dispatch(WatchlistAction.getWatchlist({}));
    }
  }, [profileData]);

  useEffect(() => {
    dispatch(UniversityAction.getUnisByBudget({ currency: currencyValue }));
  }, [profileData, currencyValue]);

  useEffect(() => {
    setShowModal(showTrialModal);
  }, [profileData]);

  useEffect(() => {
    getProfilePartValues();
    getUniPartValues();
  }, [questionnaire]);

  useEffect(() => {
    const popularSubsData = popularSubjects?.map((item, index) => ({
      label: item?.program,
      value: item?.value,
      id: item?.id,
      color: colors[index],
    }));
    setPopularSubsArray(popularSubsData);
  }, [popularSubjects]);

  useEffect(() => {
    fetchMeetings();
  }, [profileData]);

  const fetchMeetings = () => {
    const meetingPayload = {
      requestedBy: "student",
      studentId: profileData?.studentId,
      limit: 10,
      offset: 0,
    };
    dispatch(MeetingAction.getMeetingInvites(meetingPayload));
    dispatch(MeetingAction.getMeetingRequests(meetingPayload));
    dispatch(MeetingAction.getUpcomingMeetings(meetingPayload));
    dispatch(
      MeetingAction.getAllMeetingsAndCount({
        requestedBy: "student",
        studentId: profileData?.studentId,
      })
    );
  };

  const handleFilterSelectBudget = (label) => {
    let filter = {};
    if (label === "0 - 15k") {
      filter = { ...filter, budget: "0-15000" };
    } else if (label === "15k - 30k") {
      filter = { ...filter, budget: "15000-30000" };
    }
    if (label === "30k - 45k") {
      filter = { ...filter, budget: "30000-45000" };
    }
    if (label === "45k - 60k") {
      filter = { ...filter, budget: "45000-60000" };
    }
    if (label === "> 60k") {
      filter = { ...filter, budget: "60000-" };
    }
    dispatch(
      SearchAction.uniSearch({
        ...filter,
        pageNo: 1,
      })
    );
    navigate("/universities/list");
  };

  const handleFilterSelectCountry = (label) => {
    let filter = { region: [label] };

    dispatch(
      SearchAction.uniSearch({
        ...filter,
        pageNo: 1,
      })
    );
    navigate("/universities/list");
  };

  const handleFilterSelectSubject = (label) => {
    let filter = { areaOfStudy: [label] };

    dispatch(
      SearchAction.uniSearch({
        ...filter,
        pageNo: 1,
      })
    );
    navigate("/universities/list");
  };

  const handleTrialModal = () => {
    dispatch(
      IndividualStudentAction.updateTrialModal(() => setShowModal(false))
    );
  };
  const getProfilePartValues = () => {
    const profileArray = [
      {
        title: "General",
        value: questionnaire?.completion?.generalCompletion ?? 0,
        route: "/profile-builder/general-info",
      },
      {
        title: "Address",
        value: questionnaire?.completion?.addressCompletion ?? 0,
        route: "/profile-builder/address",
      },
      {
        title: "Education",
        value: questionnaire?.completion?.educationCompletion ?? 0,
        route: "/profile-builder/education",
      },
      {
        title: "High School Grades",
        value: questionnaire?.completion?.highSchoolGradesCompletion ?? 0,
        route: "/profile-builder/high-school-grades",
      },
      {
        title: "Test Scores",
        value: questionnaire?.completion?.testScoresCompletion ?? 0,
        route: "/profile-builder/test-scores",
      },
      {
        title: "Contact",
        value: questionnaire?.completion?.contactsCompletion ?? 0,
        route: "/profile-builder/contacts",
      },
      {
        title: "Counselor",
        value: questionnaire?.completion?.counselorCompletion ?? 0,
        route: "/profile-builder/counselor",
      },
      {
        title: "Acitivities",
        value: questionnaire?.completion?.activitiesCompletion ?? 0,
        route: "/profile-builder/activities",
      },
    ];

    const completed100 = profileArray.filter((item) => item.value === 100);
    const notCompleted = profileArray.filter((item) => item.value !== 100);

    let sortedProfile = [];

    if (completed100.length > 0) {
      sortedProfile = [
        completed100[completed100?.length - 1],
        ...notCompleted.slice(0, 3),
      ];
    } else {
      sortedProfile = notCompleted.slice(0, 4);
    }

    if (completed100.length === profileArray.length) {
      sortedProfile = profileArray.slice(0, 4);
    }

    if (sortedProfile.length < 4) {
      const additionalItems = [...notCompleted, ...completed100].filter(
        (item) => !sortedProfile.includes(item)
      ); // Avoid duplicates

      sortedProfile = [
        ...sortedProfile,
        ...additionalItems.slice(0, 4 - sortedProfile.length),
      ];
    }
    sortedProfile.sort((a, b) => b.value - a.value);
    setProfileArrayData(sortedProfile);
  };

  const getUniPartValues = () => {
    const uniPrefArray = [
      {
        title: "Academics",
        value: questionnaire?.completion?.academicsCompletion ?? 0,
        route: "/profile-builder/academics",
      },
      {
        title: "Location",
        value: questionnaire?.completion?.locationCompletion ?? 0,
        route: "/profile-builder/location",
      },
      {
        title: "Financial",
        value: questionnaire?.completion?.financialCompletion ?? 0,
        route: "/profile-builder/financial",
      },
      {
        title: "People",
        value: questionnaire?.completion?.peopleCompletion ?? 0,
        route: "/profile-builder/people",
      },
      {
        title: "Facilities",
        value: questionnaire?.completion?.faciltiesCompletion ?? 0,
        route: "/profile-builder/facilities",
      },
      {
        title: "Demographics",
        value: questionnaire?.completion?.demographicsCompletion ?? 0,
        route: "/profile-builder/demographics",
      },
      {
        title: "Others",
        value: questionnaire?.completion?.othersCompletion ?? 0,
        route: "/profile-builder/others",
      },
    ];

    const completed100 = uniPrefArray.filter((item) => item.value === 100);
    const notCompleted = uniPrefArray.filter((item) => item.value !== 100);

    let sortedUni = [];

    if (completed100.length > 0) {
      sortedUni = [
        completed100[completed100?.length - 1],
        ...notCompleted.slice(0, 3),
      ];
    } else {
      sortedUni = notCompleted.slice(0, 4);
    }

    if (completed100.length === uniPrefArray.length) {
      sortedUni = uniPrefArray.slice(0, 4);
    }

    if (sortedUni.length < 4) {
      const additionalItems = [...notCompleted, ...completed100].filter(
        (item) => !sortedUni.includes(item)
      );

      sortedUni = [
        ...sortedUni,
        ...additionalItems.slice(0, 4 - sortedUni.length),
      ];
    }
    sortedUni.sort((a, b) => b.value - a.value);
    setUniPrefArrayData(sortedUni);
  };

  const popoverContent = (
    <div className="flex flex-col gap-2 p-2">
      <div className="font-bold">Overall Tasks Progress</div>
      <div className="grid grid-cols-2 gap-3">
        {tasks.map((item, index) => (
          <div className="flex gap-2 justify-left items-center" key={index}>
            <div className="text-[0.75em] font-bold">Task {index + 1}:</div>
            <div
              className={`px-3 py-1 rounded-xl text-white text-[0.625em] font-semibold capitalize leading-4 ${
                item.percCompleted < 100 && "cursor-pointer"
              }`}
              style={{
                backgroundColor: getTagColor(item.percCompleted),
              }}
              onClick={() => item.percCompleted < 100 && navigate(item?.link)}
            >
              {item?.percCompleted}%
            </div>
          </div>
        ))}
      </div>
    </div>
  );

  const applicationData = [
    {
      title: "Applying",
      value: ongoingApplicationsCount ?? 0,
      icon: Images.HomeApplying,
    },
    {
      title: "Applied",
      value: submittedApplicationsCount ?? 0,
      icon: Images.HomeApplied,
    },
    { title: "Shortlisted", value: count ?? 0, icon: Images.HomeShortlisted },
  ];

  const labelMapping = {
    fifteenToThirty: "15k - 30k",
    fourtyFiveToSixty: "45k - 60k",
    moreThanSixty: "> 60k",
    thirtyToFourtyFive: "30k - 45k",
    zeroToFifteen: "0 - 15k",
  };

  const dataset = [
    {
      choice1: 59,
      choice2: 57,
      choice3: 86,
      country: "Australia",
      countryCode: "AU",
      countryId: 5,
    },
    {
      choice1: 50,
      choice2: 52,
      choice3: 78,
      country: "Canada",
      countryCode: "CA",
      countryId: 9,
    },
    {
      choice1: 47,
      choice2: 53,
      choice3: 106,
      country: "UK",
      countryCode: "GB",
      countryId: 2,
    },
    {
      choice1: 54,
      choice2: 56,
      choice3: 92,
      country: "USA",
      countryCode: "US",
      countryId: 1,
    },
  ];

  const uData = [59, 60, 57, 86];
  const pData = [47, 60, 53, 106];
  const qData = [54, 60, 56, 92];
  const yLabels = ["Australia", "Canada", "UK", "USA"];

  const xlabels = Object.keys(universitiesByBudget).map(
    (key) => labelMapping[key]
  );
  const xdata = Object.values(universitiesByBudget);

  const recommenderData = [
    {
      title: (
        <StatusIndicator
          text={
            <div className="flex justify-center items-center w-[12em] gap-5">
              <div>Aspirational</div>
              <div>1 - 20%</div>
            </div>
          }
          showarrow={false}
          color="red"
        />
      ),
      popoverText:
        "Our AI Recommender estimates a 1-20% chance you will get into a university if shows under the Aspirational Option after you use our Recommender.",
    },
    {
      title: (
        <StatusIndicator
          text={
            <div className="flex justify-center items-center w-[10em] gap-5">
              <div>Solid</div>
              <div>21 - 60%</div>
            </div>
          }
          showarrow={false}
          color="yellow"
        />
      ),
      popoverText:
        "Our AI Recommender estimates a 21-60% chance you will get into a university if shows under the Solid Option after you use our Recommender.",
    },
    {
      title: (
        <StatusIndicator
          text={
            <div className="flex justify-center items-center w-[10em] gap-5">
              <div>Safe</div>
              <div>61 - 100%</div>
            </div>
          }
          showarrow={false}
          color="green"
        />
      ),
      popoverText:
        "Our AI Recommender estimates a 61-100% chance you will get into a university if shows under the Safe Option after you use our Recommender.",
    },
  ];

  const intershipData = {
    icon: Images.UnivisionLogoRound,
    title: "Data Intern",
    company: "UniVision",
    tags: ["Data Processing", "ETL", "SQL", "Python"],
    salary: "AED 600 - 1,000",
    employmentType: "Part Time",
    jobType: "Hybrid",
    description:
      "Here at UniVision (Dubai) we have an excition opportunity for a Data Intern. The position is located at our Dubai Commerce City office.",
    link: "https://univision.hk/careers",
  };
  return (
    <div className="home-container">
      <div className="home-first-row">
        <div>
          <div className="box-title">Applications</div>
          <Spacer height={10} />
          <boxContainer.LiteBoxContainer>
            <div className="grid grid-cols-3 h-[10.625em]">
              {applicationData?.map((item, index) => (
                <div
                  className="flex flex-col gap-3 items-center justify-center"
                  key={index}
                >
                  <img src={item.icon} className="h-[2.75em]" />
                  <div
                    className={`flex flex-col gap-3 items-center justify-center w-full ${
                      index < applicationData?.length - 1 &&
                      "border-r-[0.125em]  pr-2"
                    }`}
                  >
                    <div className="text-[1.125em] font-semibold">
                      {item.title}
                    </div>
                    <div className="text-[1.75em] font-bold">{item.value}</div>
                  </div>
                </div>
              ))}
            </div>
          </boxContainer.LiteBoxContainer>
        </div>
        <div>
          <div className="box-title">Profile Builder Progress</div>
          <Spacer height={10} />
          <boxContainer.LiteBoxContainer>
            <div className="flex flex-col h-[10.625em] pl-3">
              <div className="flex flex-col gap-1 border-b-[0.125em] border-dashed border-b-gray-300 px-2 pb-2">
                <div className="font-bold">Profile Information</div>
                <div className="flex gap-4 justify-between">
                  {profileArrayData?.map((item, index) => (
                    <Link
                      to={item?.route}
                      key={index}
                      className="flex flex-col gap-1 w-full"
                    >
                      <div className="relative">
                        <div className="absolute top-0 -left-3 z-[10] bg-white rounded-full">
                          {item?.value === 100 ? (
                            <FaCircleCheck
                              color={getTagColor(item?.value)}
                              fontSize={"1.5em"}
                            />
                          ) : (
                            <FaCircle
                              color={getTagColor(item?.value)}
                              fontSize={"1.5em"}
                            />
                          )}
                        </div>
                        <Progress
                          percent={item?.value}
                          percentPosition={{
                            type: "inner",
                          }}
                          trailColor="#d6d6d6"
                          strokeColor={getTagColor(item?.value)}
                          className="profile-progress"
                        />
                      </div>
                      <div
                        className="text-[0.75em] pr-2 font-semibold line-clamp-1 text-ellipsis"
                        title={item?.title}
                      >
                        {item?.title}
                      </div>
                    </Link>
                  ))}
                </div>
              </div>
              <div className="flex flex-col gap-2 px-2 pt-1">
                <div className="font-bold">University Preference</div>
                <div className="flex gap-4 justify-between">
                  {uniPrefArrayData?.map((item, index) => (
                    <Link
                      to={item?.route}
                      key={index}
                      className="flex flex-col gap-1 w-full"
                    >
                      <div className="relative">
                        <div className="absolute top-0 -left-3 z-[10] bg-white rounded-full">
                          {item?.value === 100 ? (
                            <FaCircleCheck
                              color={getTagColor(item?.value)}
                              fontSize={"1.5em"}
                            />
                          ) : (
                            <FaCircle
                              color={getTagColor(item?.value)}
                              fontSize={"1.5em"}
                            />
                          )}
                        </div>
                        <Progress
                          percent={item?.value}
                          percentPosition={{
                            type: "inner",
                          }}
                          trailColor="#d6d6d6"
                          strokeColor={getTagColor(item?.value)}
                          className="profile-progress"
                        />
                      </div>
                      <div className="text-[0.75em] pr-2 font-semibold">
                        {item?.title}
                      </div>
                    </Link>
                  ))}
                </div>
              </div>
            </div>
          </boxContainer.LiteBoxContainer>
        </div>
        <div>
          <div className="box-title">Your Tasks</div>
          <Spacer height={10} />
          <boxContainer.LiteBoxContainer>
            {isTasksLoading ? (
              <Loader.Circular />
            ) : (
              <div className="flex flex-col justify-between gap-2 h-[10.625em]">
                <div className="w-full border-b-[0.125em] border-dashed border-gray-300">
                  {tasks?.length > 0 ? (
                    <task.TasksCarousel items={tasks} />
                  ) : (
                    <div className="text-[1.125em] font-semibold px-5">
                      Well done! You have completed all the tasks!
                    </div>
                  )}
                </div>

                <popover.WhitePopover
                  trigger="hover"
                  placement="bottom"
                  content={popoverContent}
                >
                  <div>
                    <progressBar.DefaultProgress percent={taskPercentage} />
                  </div>
                </popover.WhitePopover>
              </div>
            )}
          </boxContainer.LiteBoxContainer>
        </div>
      </div>
      {/* <Spacer height={10} /> */}
      <div className="home-second-row">
        <div>
          <div className="box-title">Total Universities by Budget (USD)</div>
          <Spacer height={10} />
          <boxContainer.LiteBoxContainer>
            {isUniByBudgetLoading ? (
              <div className="h-[21.875em] flex items-center justify-center">
                <Loader.Circular />
              </div>
            ) : (
              <>
                {!universitiesByBudget?.zeroToFifteen ? (
                  <div className="h-[21.875em] flex items-center justify-center">
                    <Empty />
                  </div>
                ) : (
                  <div>
                    {/* <div className="w-full flex justify-end">
                      <div className="w-[9.375em]">
                        <inputFields.SelectDropdownSmall
                          items={UtilityArrays.homeCurrency}
                          onChange={(e) => setCurrencyValue(e)}
                          value={currencyValue}
                        />
                      </div>
                    </div> */}
                    <div
                      style={{
                        backgroundImage: `url(${Images.WorldMapDotted})`,
                        backgroundRepeat: "no-repeat",
                        backgroundSize: "cover",
                      }}
                    >
                      <Charts.VerticalBarChart
                        xdata={xlabels}
                        series={[{ data: xdata }]}
                        onItemClick={(event, batItemIdentifier) => {
                          const dataIndex = batItemIdentifier.dataIndex;
                          const label =
                            labelMapping[
                              Object.keys(universitiesByBudget)[dataIndex]
                            ];

                          handleFilterSelectBudget(label);
                        }}
                      />
                    </div>
                  </div>
                )}
              </>
            )}
          </boxContainer.LiteBoxContainer>
        </div>
        <div>
          <div className="box-title">Popular Countries</div>
          <Spacer height={10} />
          <boxContainer.LiteBoxContainer>
            {isPopularCountryLoading ? (
              <Loader.Circular />
            ) : (
              <>
                {popularCountries?.length === 0 ? (
                  <div className="h-[21.875em] flex items-center justify-center">
                    <Empty />
                  </div>
                ) : (
                  <div
                    style={{
                      backgroundImage: `url(${Images.WorldMapDotted})`,
                      backgroundRepeat: "no-repeat",
                      backgroundSize: "cover",
                      height: "21.875em",
                      position: "relative",
                    }}
                  >
                    <div className="absolute h-[19.6875em] w-[9.5em] left-0 top-0 flex flex-col justify-between">
                      {dataset?.map((item, index) => (
                        <div
                          className="flex flex-1 w-full items-center justify-left gap-3 pl-4"
                          key={index}
                        >
                          <ReactCountryFlag
                            countryCode={item.countryCode}
                            svg
                            style={{
                              width: "1.925em",
                              height: "1.925em",
                              borderRadius: "0.825em",
                            }}
                            title={item.countryCode}
                          />
                          <div className="font-semibold text-[1.25em]">
                            {item?.country}
                          </div>
                        </div>
                      ))}
                    </div>
                    <Charts.HorizontalBarChart
                      ydata={yLabels}
                      series={[
                        {
                          label: "1st Choice",
                          data: uData,
                          color: "#387f75",
                        },
                        {
                          label: "2nd Choice",
                          data: pData,
                          color: "#5aee9c",
                        },
                        {
                          label: "3rd Choice",
                          data: qData,
                          color: "#bc4642",
                        },
                      ]}
                      onItemClick={(event, batItemIdentifier) => {
                        const dataIndex = batItemIdentifier.dataIndex;
                        const label = dataset[dataIndex]?.countryId;
                        handleFilterSelectCountry(label);
                      }}
                    />
                    <div className="absolute flex gap-4 items-center bottom-2 left-2">
                      {["1st Choice", "2nd Choice", "3rd Choice"].map(
                        (item, index) => (
                          <div className="flex gap-2 items-center" key={index}>
                            <div
                              className="h-[0.625em] w-[0.875em]"
                              style={{ backgroundColor: colors[index] }}
                            ></div>
                            <div className="text-[0.825em] font-semibold">
                              {item}
                            </div>
                          </div>
                        )
                      )}
                    </div>
                  </div>
                )}
              </>
            )}
          </boxContainer.LiteBoxContainer>
        </div>
        <div>
          <div className="box-title">Popular Subjects</div>
          <Spacer height={10} />
          <boxContainer.LiteBoxContainer>
            {isPopularSubsLoading ? (
              <Loader.Circular />
            ) : (
              <>
                {popularSubsArray?.length === 0 ? (
                  <div className="h-[21.875em] flex items-center justify-center">
                    <Empty />
                  </div>
                ) : (
                  <div className="flex justify-center flex-col items-center h-[21.875em]">
                    <Charts.PieChartDashboard
                      data={popularSubsArray}
                      onSubjectClick={handleFilterSelectSubject}
                    />
                    <div className="flex gap-x-3 gap-y-2 flex-wrap items-center justify-center font-semibold text-[0.75em]">
                      {popularSubsArray?.map((item, index) => {
                        return (
                          <div
                            className="flex gap-2 items-center justify-center"
                            key={index}
                          >
                            <div
                              className="h-[0.625em] w-[1.875em]"
                              style={{ backgroundColor: colors[index] }}
                            ></div>
                            <div>{item?.label}</div>
                          </div>
                        );
                      })}
                    </div>
                  </div>
                )}
              </>
            )}
          </boxContainer.LiteBoxContainer>
        </div>
      </div>
      {/* <Spacer height={10} /> */}
      {profileData?.student?.studentType === "individualStudent" ? (
        <div className="home-third-row">
          <div>
            <div className="box-title">AI Recommender</div>
            <Spacer height={10} />
            <boxContainer.LiteBoxContainer>
              <div className="px-3 py-1 h-[20em]">
                <div className="flex gap-3">
                  <div className="w-[60%] flex flex-col gap-3">
                    <div className="text-main font-bold text-[1.25em]">
                      Are You Facing Difficulties Choosing Universities?
                    </div>
                    <div className="text-[1.125em] font-semibold">
                      Use our proprietary recommender feature to help you find
                      the best university based on your requirements. Take a
                      peek at the video below to see how it works!
                    </div>
                    <div className="w-[11.25em]">
                      <Buttons.DefaultButton
                        width="full"
                        size="medium"
                        onClick={() => navigate("/recommender")}
                      >
                        Start
                      </Buttons.DefaultButton>
                    </div>
                  </div>
                  <div className="w-[40%]">
                    <img src={Images.Homerecommender} className="w-[15em]" />
                  </div>
                </div>
                <Spacer height={20} />
                <div className="flex justify-between">
                  {recommenderData?.map((item, index) => (
                    <popover.WhitePopover
                      content={
                        <div className="max-w-[18.75em] font-medium">
                          {item.popoverText}
                        </div>
                      }
                      trigger="hover"
                      placement="top"
                    >
                      <div>{item?.title}</div>
                    </popover.WhitePopover>
                  ))}
                </div>
              </div>
            </boxContainer.LiteBoxContainer>
          </div>
          <div>
            <div className="box-title">Internships</div>
            <Spacer height={10} />
            <boxContainer.LiteBoxContainer>
              {profileData?.freeUser ? (
                <div className="h-[20em] flex justify-center items-center">
                  <GetProPopup />
                </div>
              ) : (
                <div className="p-2 h-[20em] overflow-auto flex flex-col justify-between">
                  <div>
                    <div className="flex justify-between gap-2">
                      <div className="flex gap-2">
                        {intershipData?.icon && (
                          <img
                            src={intershipData?.icon}
                            className="h-[2.875em]"
                          />
                        )}
                        <div>
                          <div className="text-[1.125em] font-bold">
                            {intershipData.title}
                          </div>
                          <div className="text-[0.875em] font-medium">
                            {intershipData.company}
                          </div>
                        </div>
                      </div>
                      <div>
                        <Link to={intershipData?.link} target="_blank">
                          <Buttons.DefaultButton size="small">
                            Apply Now
                          </Buttons.DefaultButton>
                        </Link>
                      </div>
                    </div>
                    <Spacer height={20} />
                    <div className="flex gap-2 flex-wrap">
                      {intershipData?.tags?.map((item, index) => (
                        <div
                          className="text-[0.875em] border border-green-100 bg-liteBoxBg rounded-[1.25em] p-2"
                          key={index}
                        >
                          {item}
                        </div>
                      ))}
                    </div>
                    <Spacer height={20} />
                    <div className="flex gap-2 flex-wrap">
                      <div className="flex gap-2 justify-center items-center font-medium border-r pr-2">
                        <HiMiniCurrencyDollar
                          fontSize={"1.125em"}
                          color={Colors.main}
                        />
                        {intershipData?.salary}
                      </div>

                      <div className="flex gap-2 justify-center items-center font-medium border-r pr-2">
                        <HiBriefcase fontSize={"1.125em"} color={Colors.main} />
                        {intershipData?.employmentType}
                      </div>

                      <div className="flex gap-2 justify-center items-center font-medium pr-2">
                        <PiMonitorFill
                          fontSize={"1.125em"}
                          color={Colors.main}
                        />
                        {intershipData?.jobType}
                      </div>
                    </div>
                    <Spacer height={20} />
                    <div>{intershipData?.description}</div>
                  </div>
                  <div className="w-[8.75em]">
                    <Link to="/internships">
                      <Buttons.WhiteButton size="small" width="full">
                        Explore All
                      </Buttons.WhiteButton>
                    </Link>
                  </div>
                </div>
              )}
            </boxContainer.LiteBoxContainer>
          </div>
          <div>
            <div className="box-title">Suggestions</div>
            <Spacer height={10} />
            <boxContainer.LiteBoxContainer>
              {isSuggestionsLoading ? (
                <Loader.Circular />
              ) : (
                <div className="h-[20em] overflow-auto">
                  {suggestions?.map((item, index) => (
                    <div
                      className={`flex gap-2 items-center p-3 font-semibold ${
                        index < suggestions?.length - 1 &&
                        "border-b border-b-gray-300"
                      } ${item?.link && "cursor-pointer"}`}
                      key={index}
                      onClick={() => navigate(item?.link)}
                    >
                      <div className="w-[8%] flex justify-center items-center">
                        <img
                          src={
                            item?.title?.startsWith("Deadline")
                              ? Images.HomeDeadline
                              : Images.HomeSuggestion
                          }
                          className="w-[30.125em]"
                        />
                      </div>
                      <div className="w-[92%]">{item?.title}</div>
                    </div>
                  ))}
                </div>
              )}
            </boxContainer.LiteBoxContainer>
          </div>
        </div>
      ) : (
        <div>
          <div>
            <div className="box-title">Meetings</div>
            <Spacer height={10} />
            <boxContainer.LiteBoxContainer>
              <div className="px-3">
                <div className="home-meeting-row">
                  <div>
                    <UpcomingMeetings />
                    <Spacer height={30} />
                    <div>
                      <MeetingTabs
                        meetingTab={meetingTab}
                        setMeetingTab={setMeetingTab}
                        meetingSentCount={meetingSentCount}
                        meetingInvitesCount={meetingInvitesCount}
                      />
                    </div>
                  </div>
                  <div>
                    <div className="box-title">My Calendar</div>
                    <Spacer height={10} />
                    <boxContainer.LiteBoxContainer bg="bg-[#f6fbf9] h-full">
                      <div className="flex flex-col justify-around items-end h-full">
                        <customCalendar.MeetingCalendar
                          meetingData={meetingsAll?.allMeetings}
                        />
                        <Link to="/meetings/add-meeting">
                          <Buttons.DefaultButton size="small">
                            New Meeting
                          </Buttons.DefaultButton>
                        </Link>
                      </div>
                    </boxContainer.LiteBoxContainer>
                  </div>

                  <div>
                    <div className="box-title">Suggestions</div>
                    <Spacer height={10} />
                    <boxContainer.LiteBoxContainer>
                      {isSuggestionsLoading ? (
                        <Loader.Circular />
                      ) : (
                        <div className="max-h-[19.25em] overflow-auto">
                          {suggestions?.map((item, index) => (
                            <div
                              className={`flex gap-2 items-center p-3 font-semibold ${
                                index < suggestions?.length - 1 &&
                                "border-b border-b-gray-300"
                              } ${item?.link && "cursor-pointer"}`}
                              key={index}
                              onClick={() => navigate(item?.link)}
                            >
                              <div className="w-[8%] flex justify-center items-center">
                                <img
                                  src={
                                    item?.title?.startsWith("Deadline")
                                      ? Images.HomeDeadline
                                      : Images.HomeSuggestion
                                  }
                                  className="w-[30.125em]"
                                />
                              </div>
                              <div className="w-[92%]">{item?.title}</div>
                            </div>
                          ))}
                        </div>
                      )}
                    </boxContainer.LiteBoxContainer>
                  </div>
                </div>
                <Spacer height={20} />

                <div>
                  {meetingTab === "sent" ? (
                    <MeetingsSent />
                  ) : (
                    <MeetingsReceived />
                  )}
                </div>
              </div>
            </boxContainer.LiteBoxContainer>
          </div>
        </div>
      )}

      <Spacer height={10} />
      <div>
        <div className="box-title">Top Stories</div>
        <Spacer height={10} />
        <boxContainer.LiteBoxContainer>
          {isTopStoriesLoading ? (
            <Loader.Circular />
          ) : (
            <topStoriesComponents.TopStoriesSwiper data={topStories} />
          )}
        </boxContainer.LiteBoxContainer>
      </div>
      <Modal.DefaultModal
        open={showModal}
        closeIcon={false}
        onCancel={() => handleTrialModal()}
      >
        <div className="flex flex-col items-center justify-center gap-4 px-5 py-4 text-center text-[1.125em] w-[31.25em]">
          <img src={Images.LogoIconOnly} className="h-[4.125em]" />
          <div className="font-bold">
            Congratulations, {profileData.firstName} {profileData.lastName}!
          </div>
          <div className="font-semibold">
            You have been given a free trial of the{" "}
            <span className="font-bold text-main">UniVision Pro</span> for one
            month! After the free tiral, if you want to continue using{" "}
            <span className="font-bold text-main">UniVision Pro</span> platform
            please select a payment plan. Otherwise, you can continue using
            UniVision as a free user.
          </div>
          <div className="w-[15.625em]">
            <Buttons.DefaultButton
              width="full"
              onClick={() => handleTrialModal()}
            >
              Continue
            </Buttons.DefaultButton>
          </div>
        </div>
      </Modal.DefaultModal>
    </div>
  );
};

export default Home;
